// Copyright (C) Microsoft Corporation. All rights reserved.

/* eslint "@microsoft/sdl/no-inner-html": "off" */

import 'core-js/features/promise';
import { fetch } from 'whatwg-fetch';

export const isAuthenticationChallenge = (response: Response) =>
	response.status === 401 ||
	response.type === "opaqueredirect" ||
	(response.status >= 300 && response.status < 400);

export const getSignInUrl = (returnUrl: string) =>
	`/Authentication/SignIn?ru=${encodeURIComponent(returnUrl)}`;

const resetAjaxHtmlAndError = () => {
	const ajaxHtml: HTMLDivElement = $("#ajax-html").get(0) as HTMLDivElement;
	const errorMessage: HTMLParagraphElement = $("#error-message").get(0) as HTMLParagraphElement;

	ajaxHtml.setAttribute("hidden", "");
	ajaxHtml.innerHTML = "";
	ajaxHtml.className = "";

	errorMessage.setAttribute("hidden", "");
	errorMessage.textContent = "";
}

/**
	* Handles the product-image-selector "change" event.
	* @param event The event object
	*/
const onProductImageSelectorChange = (event: JQueryEventObject) => {
	// Get a handle to all elements involved in the event
	let selectElement = event.target as HTMLSelectElement;
	let selectedOption: HTMLOptionElement = selectElement.options[selectElement.selectedIndex];
	let imgSrc = selectedOption.dataset.imgsrc;
	let imgAltText = selectedOption.dataset.alt;
	let imageElement = <HTMLImageElement>document.getElementById("product-serial-image");

	// Update the img element attributes.
	imageElement.src = imgSrc;
	imageElement.alt = imgAltText;
	imageElement.ariaLabel = imgAltText;
	imageElement.title = imgAltText;

	imageElement.removeAttribute("hidden");
	imageElement.classList.remove("ocHidden");
}

/**
	* Handles the product-serial-form "submit" event
	* @param event The event object
	*/
const onProductSerialFormSubmit = async (event: JQueryEventObject) => {
	event.preventDefault();

	const form = event.target as HTMLFormElement;
	const ajaxHtml: HTMLDivElement = $("#ajax-html").get(0) as HTMLDivElement;
	const errorMessage: HTMLParagraphElement = $("#error-message").get(0) as HTMLParagraphElement;

	try {

		resetAjaxHtmlAndError();

		// Display the 'please wait' animation.
		ajaxHtml.className = "please-wait";
		ajaxHtml.removeAttribute("hidden");

		// Reset the error message's content and hide the element.
		errorMessage.textContent = "";
		errorMessage.setAttribute("hidden", "");

		// AJAX post the form data.
		const response = await fetch(form.action, {
			method: form.method,
			body: new FormData(form),
			redirect: "manual"
		});

		// Hide the AJAX HTML placeholder while it's being updated to prevent flashes.
		ajaxHtml.setAttribute("hidden", "");
		if (isAuthenticationChallenge(response)) {
			window.location.assign(getSignInUrl(window.location.href));
			return;
		}

		if (response.status == 200) {

			// Set the AJAX HTML text
			/* TODO: Task 6407913: Update div.InnerHtml = raw html to React dangerouslySetHtml */
			const htmlText:string = await response.text();
			ajaxHtml.innerHTML = htmlText;
		} else {
			let problemDetails = await response.json();
			errorMessage.textContent = problemDetails.detail;
			errorMessage.removeAttribute("hidden");
		}
	} catch (error) {
		errorMessage.textContent = error;
		errorMessage.removeAttribute("hidden");
	}
	finally {
		ajaxHtml.className = "";
		ajaxHtml.removeAttribute("hidden");
	}
}

export function Init() {
	const $productImageSelector: JQuery<HTMLSelectElement> = $("#product-name-select");
	const $productSerialForm: JQuery<HTMLFormElement> = $("#product-serial-form");

	$productImageSelector.on("change", onProductImageSelectorChange);
	$productSerialForm.on("submit", onProductSerialFormSubmit);
}
